import { EpkModuleApiService } from '~packages/epk-front-shared/api-client';
import { Mode } from '~packages/json-api/client';

import getConstants from '@/constants';
import { cacheDictNames, useDictionariesStore } from '@/store';

import { DictType } from '../types/DictsApiService';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'DictsApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  needInit: isModeDevelopment,
};

export default class DictsApiService extends EpkModuleApiService {
  _dictStore = useDictionariesStore();

  constructor() {
    super(constructorParams);
  }

  async getByName(name, params) {
    if (params) {
      return await this._sendRequest(
        this.pathFetch + name,
        params,
        { method: this.requestMethodFetch },
        { dataOptions: { name }, method: 'fetch' }
      );
    } else {
      return await super.fetch(name);
    }
  }

  async createDictItem(name, params) {
    return await this._sendRequest(
      this.pathAdd + name,
      null,
      { method: this.requestMethodAdd, body: JSON.stringify(params) },
      { method: 'add' }
    );
  }

  async getDictsName(type: DictType) {
    const req = async () =>
      await this._sendRequest(
        this.pathFetch + type,
        { use_pagination: false, sort: 'code' },
        { method: this.requestMethodFetch },
        { method: 'getDictsName' }
      );

    if (cacheDictNames.has(type)) {
      const store = this._dictStore;
      const [dict, length] = store.getDictData(type);
      if (length) return dict;

      const data = await req();
      store.setDictData(type, data.response.data);
      return data;
    }

    return await req();
  }
}
